// src/hooks/useNetwork.js
import { useEffect, useState } from "react";
import { jornadaStore } from "../data/jornadaStore";
import { ticajeStore } from "../data/ticajeStore";

/**
 * Hook de red:
 * - Devuelve { online } para la UI.
 * - Sincroniza jornadaStore y ticajeStore con el estado real de la red.
 * - Si recibes un onChange, también se sigue llamando (compatibilidad).
 */
export function useNetwork(onChange) {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const apply = (value) => {
      setOnline(value);

      // Avisar a los stores (esto dispara reconcile() al pasar de false -> true)
      try {
        jornadaStore?.setOnline?.(value);
      } catch (e) {
        console.warn("[useNetwork] jornadaStore.setOnline error:", e);
      }

      try {
        ticajeStore?.setOnline?.(value);
      } catch (e) {
        console.warn("[useNetwork] ticajeStore.setOnline error:", e);
      }

      // Callback opcional que ya usabas
      onChange?.(value);
    };

    const up = () => apply(true);
    const down = () => apply(false);

    // Sincronización inicial por si el componente se monta con la red ya cambiada
    apply(navigator.onLine);

    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, [onChange]);

  return { online };
}
